<i
  class="ui-sortable-column-icon pi pi-fw"
  [ngClass]="{'pi-sort-up': sortOrder === 1, 'pi-sort-down': sortOrder === -1, 'pi-sort': sortOrder === 0}"
></i>
